// extracted by mini-css-extract-plugin
export default {"NotVerified":"NotVerified_NotVerified__WVXwT"};